import DeliveryRegionRoutingEditComponent from './delivery_region_routing.edit.component';

const DeliveryRegionRoutingEditModule = angular.module('deliveryRegionRoutingEdit', [])

    .component('deliveryRegionRoutingEdit', DeliveryRegionRoutingEditComponent)

    .name;

export default DeliveryRegionRoutingEditModule;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/edit/index.js